import { WebchatConfig } from './webchat-config';

export interface MultiLocationWebchatConfig
  extends Pick<
    WebchatConfig,
    | 'color'
    | 'textColor'
    | 'accentColor'
    | 'accentTextColor'
    | 'position'
    | 'name'
    | 'welcomeMessage'
    | 'assistantName'
    | 'assistantAvatarUrl'
    | 'showFooterContent'
    | 'poweredByName'
    | 'poweredByUrl'
  > {
  groupId: string;
  readonly widgetType: 'group';
}

export function isMultiLocationConfig(config: unknown): config is MultiLocationWebchatConfig {
  return typeof config === 'object' && config !== null && 'widgetType' in config && (config as { widgetType: unknown }).widgetType === 'group';
}
